import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { query } from "lib/graphql/query"

export const getApplyTailoringScheduleTargets = api(async function applyTailoringScheduleTargets({
    treeId,
    schedulePath,
}) {
    if (!treeId || !schedulePath) return []
    // Failures resolve to null (never an empty list): the dialog previously rendered any error as
    // "No other schedules match this original schedule code", which hid real faults from QA (FIQ-1632).
    // A thrown error would leave useResults stuck on its loading value, so it is normalised here.
    try {
        return (
            (await query(
                gql`
                    query ApplyTailoringScheduleTargets($treeId: String!, $schedulePath: String!) {
                        applyTailoringScheduleTargets(treeId: $treeId, schedulePath: $schedulePath) {
                            schedulePath
                            scheduleId
                            groupId
                            title
                            code
                            location
                        }
                    }
                `,
                { treeId, schedulePath },
                { returns: "applyTailoringScheduleTargets" }
            )) ?? null
        )
    } catch (e) {
        console.error("applyTailoringScheduleTargets failed", e)
        return null
    }
})

export const applyTailoringToSchedules = api(function applyTailoringToSchedules({
    treeId,
    sourceSchedulePath,
    targetSchedulePaths,
    payload,
}) {
    return mutate(
        gql`
            mutation ApplyTailoringToSchedules(
                $treeId: String!
                $sourceSchedulePath: String!
                $targetSchedulePaths: [String!]!
                $payload: JSONObject!
            ) {
                applyTailoringToSchedules(
                    treeId: $treeId
                    sourceSchedulePath: $sourceSchedulePath
                    targetSchedulePaths: $targetSchedulePaths
                    payload: $payload
                ) {
                    applied
                    skipped
                    commentJustificationsApplied
                }
            }
        `,
        { treeId, sourceSchedulePath, targetSchedulePaths, payload },
        { returns: "applyTailoringToSchedules" }
    )
})
